import { useCallback, useRef, useState } from 'react';

type Direction = 'horizontal' | 'vertical';

export function useIsOverflowing(
  direction: Direction = 'horizontal',
): [React.RefCallback<HTMLElement>, boolean] {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const observerRef = useRef<ResizeObserver | null>(null);

  const ref = useCallback(
    (node: HTMLElement | null) => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }

      if (node) {
        const check = () => {
          const isOverflow =
            direction === 'horizontal'
              ? node.scrollWidth > node.clientWidth
              : node.scrollHeight > node.clientHeight;
          setIsOverflowing(isOverflow);
        };
        check();
        if (typeof ResizeObserver === 'undefined') return;
        observerRef.current = new ResizeObserver(check);
        observerRef.current.observe(node);
      }
    },
    [direction],
  );

  return [ref, isOverflowing];
}
